<template>
  <div class="flex-1 flex flex-col gap-y-8">
    <div class="flex-1 w-full flex justify-between flex-col md:flex-row gap-8">
      <form action="" class="w-full md:w-[50%]" @submit.prevent="onSubmit">
        <TextInput
          :show-error-spacer="false"
          :label="$t('IdentityNumber')"
          :rules="rules"
          direction="flex-col justify-start"
          label-class="w-full"
          field-name="eid"
          placeholder="###-####-#######-#"
          mask="###-####-#######-#"
        ></TextInput>
      </form>
      <div class="w-full flex-1 md:w-1/3 h-full p-4 flex justify-center">
        <img src="@/assets/jpgs/id-img.jpg" alt="eid mockup" class="h-full" />
      </div>
    </div>
    <FormFooter @onBack="$emit('onBack')" @onNext="$emit('onNext')"></FormFooter>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import TextInput from '@/components/Form/TextInput.vue'
import FormFooter from '@/components/Onboarding/FormFooter.vue'

const rules = ref([
  {
    name: 'required',
    message: 'INVALID_REQUIRED'
  }
])
</script>

<style lang="scss" scoped></style>
